export const POST_SHOW_MAX_CONTENT_WIDTH = 720;
